export default __webpack_public_path__ + "locales/sr-Cyrl-RS/MainBar.json?hash=9daa771c33d074ff4abbb11c329a03f2";